﻿import { HelmetDexteel, useUserContext } from "@dexteel/mesf-core";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { TaskListProvider } from "./context/taskListContext";
import { useInitialValues } from "./filters/hooks/useInitialValues";
import { TaskListByAreas } from "./task-list-by-area/task-list-by-area";
import { TaskListbyDownHours } from "./task-list-by-down-hours/task-list-by-down-hours";

export default function TaskListIndex() {
	const { AssetIdParam } = useParams();
	const navigate = useNavigate();
	const location = useLocation();

	const {
		state: { defaultAreaId },
	} = useUserContext();

	useInitialValues();

	const isDowndayRoute = location.pathname.includes("/downday");
	const isAreaRoute = location.pathname.includes("/area");

	// Treat a missing or non-numeric area (e.g. "null"/"undefined" left behind
	// when the page is opened in a new tab before the user context has loaded)
	// as no area at all, so we redirect to the default area instead of querying
	// the backend with an invalid id.
	const hasValidAreaParam =
		!!AssetIdParam && Number.isInteger(Number(AssetIdParam));

	if (!hasValidAreaParam) {
		// On a fresh page load defaultAreaId is null for the first renders;
		// wait until it resolves before redirecting to avoid building
		// "/task-list/area/null".
		if (defaultAreaId === null || defaultAreaId === undefined) {
			return null;
		}
		if (isDowndayRoute) {
			navigate(`/task-list/downday/${defaultAreaId}`, { replace: true });
		} else {
			navigate(`/task-list/area/${defaultAreaId}`, { replace: true });
		}
		return null;
	}

	if (isAreaRoute) {
		return (
			<>
				<HelmetDexteel title="Task List" />
				<TaskListProvider>
					<TaskListByAreas />
				</TaskListProvider>
			</>
		);
	} else if (isDowndayRoute) {
		return (
			<>
				<HelmetDexteel title="Task List" />
				<TaskListProvider>
					<TaskListbyDownHours />
				</TaskListProvider>
			</>
		);
	}

	// Default fallback to area view
	return (
		<>
			<HelmetDexteel title="Task List" />
			<TaskListProvider>
				<TaskListByAreas />
			</TaskListProvider>
		</>
	);
}
